module.exports = __webpack_public_path__ + "img/massive_user.d7a1298f.svg";